<template>
  <div class="search_images pt-5 pa-2">
    <h1>
      Search Images:-
      <b>{{this.$route.params.search_q}}</b>
    </h1>

    <!-- show images -->
    <v-flex xs12>
      <v-card>
        <v-container style="text-align:center" v-if="loading">
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </v-container>
        <v-container grid-list-sm fluid v-if="!loading">
          <v-layout row wrap>
            <v-flex v-for="n in search_imgs" :key="n.id" lg3 md4 sm6 xs12 d-flex>
              <v-card class="img-card">
                <v-img
                  :src="imgSmallSize(n.webformatURL)"
                  aspect-ratio="1.4"
                  class="grey lighten-2"
                  v-on:click="viewimagebyurl(n.largeImageURL)"
                >
                  <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </v-img>
                <!-- img info tool -->
                <img-info
                  :user="n.user"
                  :userImg="n.userImageURL"
                  :imgWFURL="n.webformatURL"
                  :id="n.id"
                ></img-info>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import imgInfo from "./tools/ImgInfo";
import { mapGetters } from "vuex";
export default {
  name: "search_images",
  data() {
    return {
      loading: true
    };
  },
  components: {
    imgInfo
  },
  computed: {
    ...mapGetters(["search_imgs"])
  },
  created() {
    this.$store
      .dispatch("SearchImages", this.$route.params.search_q)
      .then(r => {
        this.loading = r.loading;
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    imgSmallSize: function(imgUrlWF) {
      var img_id = imgUrlWF.split("/")[4].split("_")[0];
      return `https://pixabay.com/get/${img_id}_340.jpg`;
    },
    viewimagebyurl: function(imgUrl) {
      var url = imgUrl.split("/")[4].split("_")[0];
      this.$router.push({ path: `/viewimage/${url}` });
    }
  }
};
</script>
